import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import api from '../../../components/api-service';

import MainLayoutComponent from './main-layout.component';
import MainHeaderComponent from './main-header/main-header.component';

const mainLayout = angular
  .module('lmrcApp.main-layout', [
    uiRouter,
    api
  ])
  .component('mainLayout', MainLayoutComponent)
  .component('mainHeader', MainHeaderComponent)
  .config(function ($stateProvider) {
      'ngInject';

      $stateProvider

        .state('main', {
          abstract: true,
          data: {
            authRequired: true
          },
          views: {
            '': {
              component: 'mainLayout'
            }
          }
        });
  })
  .name;

export default mainLayout;




// WEBPACK FOOTER //
// ./client/app/layout/main-layout/index.js